<script lang="ts">
    import type { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
    import { REWARDS_DISCOUNT_TYPES } from "@apps/rewards/constants/rewardsDiscountTypes";
    import type { RewardsDiscountRewardEntity } from "@apps/rewards/entities/entities";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    import T from "@components/T.svelte";

    import RewardsCurrency from "../RewardsCurrency.svelte";

    //Props
    export let reward: RewardsDiscountRewardEntity;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let namespace: RewardsTranslationNamespaces;
    export let sanitizer: HTMLSanitizerInterface;

    const discount = Math.abs(reward.discountValue || 0);
</script>

{#if reward.discountType === REWARDS_DISCOUNT_TYPES.fixedAmount}
    <RewardsCurrency
        let:amount
        amount={discount}
        {currencyFormatter}
        {sanitizer}
    >
        <T
            {namespace}
            translationKey="fixed_discount_reward"
            translationOptions={{
                discount: amount,
            }}
        />
    </RewardsCurrency>
{:else if reward.discountType === REWARDS_DISCOUNT_TYPES.percentage}
    <T
        {namespace}
        translationKey="percentage_discount_reward"
        translationOptions={{
            discount,
        }}
    />
{:else}
    <T {namespace} translationKey="free_shipping_reward" />
{/if}
